module.exports = __webpack_public_path__ + "static/media/active-order-icon.a3bdc5cb.svg";